import { basenameFind, getMetaFromJcamp, getTargetProperty, } from "../common.js";
const raman = {
    jpath: ['spectra', 'raman'],
    find: basenameFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default raman;
//# sourceMappingURL=raman.js.map